/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import {keyframes} from '@chakra-ui/react'
import {colors} from '../../../constants'

export const navLinkAnimation = keyframes`
  0% {
    transform: translateX(-3px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }`

const modalAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }`

export default {
    baseStyle: {
        container: {},
        modalContent: {
            maxWidth: 'unset',
            paddingTop: '50px',
            paddingBottom: '50px'
        },
        modalBody: {
            padding: '0',
            animation: `${modalAnimation} 0.5s ease-in-out`,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        mobileNavLink: {
            backgroundColor: 'white',
            color: `${colors.blueCol}`,
            fontSize: '24px',
            fontWeight: '300',
            fontFamily: `"Raleway", sans-serif`,
            marginLeft: 'auto',
            height: 'auto',
            lineHeight: '32px',
            marginBottom: '16px',
            width: 'fit-content',
            paddingLeft: '25px',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            opacity: '0',
            maxWidth: '213px',
            whiteSpace: 'normal',
            paddingRight: '4px',
            animation: `${navLinkAnimation} 0.1s ease-in-out calc((var(--index) + 1) * 80ms) forwards`,
            _hover: {
                backgroundColor: 'white'
            },
            _active: {bg: 'white'}
        },
        cardAlignment: {
            position: 'relative',
            cursor: 'pointer',
            width: '50%',
            backgroundColor: 'white',
            height: 'auto',
            padding: '0',
            color: 'black',
            _hover: {
                backgroundColor: 'white'
            }
        },
        chevronIcon: {
            color: `${colors.borderGray}`,
            opacity: '0.8',
            width: '19px',
            height: '14px',
            marginLeft: '3px'
        },
        textAlignment: {
            position: 'absolute',
            top: '13px',
            left: '13px',
            fontFamily: 'Raleway',
            fontWeight: '300'
        },
        signout: {
            width: '100%',
            paddingLeft: 8,
            paddingRight: '26px',
            _focus: {
                borderRadius: 0,
                boxShadow: 'outline'
            }
        },
        signoutText: {
            marginLeft: 2,
            fontSize: 14,
            fontWeight: 'normal'
        },
        bookServicesBtn: {
            color: colors.black
        }
    }
}
